;( function( window ) {    
    'use strict';
    $.fn.EMonegofn = function(options){
        this.each(function(){
            new $.EMonego(this,options);
        });
    };
    $.EMonego = function(el,options){
        this.el = $(el);                
        this._init(options);
    };
    $.EMonego.defaults = {
        addrowbtn: '#addRowBtn',
        listrow:'#list-cont',
        numberadd: '#small-num',
        uploadarea: '#imgupload',
        uploadbutton: '#add-image',
    }
    $.EMonego.prototype = {
        _init: function(options){
            var self =this;
            self.options = $.extend( true, {}, $.EMonego.defaults, options );
            self.addrowbtn = self.el.find(self.options.addrowbtn);
            self.numberadd = self.el.find(self.options.numberadd);
            self.listrow = self.el.find(self.options.listrow);
            self.uploadbutton = self.el.find(self.options.uploadbutton);
            self.max = self.el.find('input[name="max_images"]').val();
            self.uploadarea = self.el.find(self.options.uploadarea);
            //self._sliderrange(self.el.find('.slider-range'));    
            self.el.find('.slider-range').each(function(){
                self._starrange($(this));
            });
            
            self._config();
        },
        _config: function(){
            var self =this;
            self.addrowbtn.click(function(){
                var number = self.numberadd.val(),i;
                    
                for(i=0;i<number;i++){
                    var clone = self._getclone();
                    //self._sliderrange(clone.find('.slider-range'));
                    self._starrange(clone.find('.slider-range'));
                    self.listrow.append(clone);
                }                
                return false;
            });        
            
            $(document).on('click','input[name="tolerance"]',function(){
                var agree = $(this).val();
                console.log(agree);
                if(agree !== 'agree'){
                //only close popup
                $.magnificPopup.close();
                }else{
                //submit again
                $.magnificPopup.close();
                self.el.submit();
                }
            });
            self.el.validate({
                errorElement: "em",
                errorPlacement: function ( error, element ) {
                    // Add the `help-block` class to the error element
                    error.addClass( "help-block" );

                    if ( element.prop( "type" ) === "checkbox" ) {
                        error.insertAfter( element.parent( "label" ) );
                    } else {
                        error.insertAfter( element );
                    }
                },
                highlight: function ( element, errorClass, validClass ) {
                    $( element ).closest('div' ).addClass( "has-error" ).removeClass( "has-success" );
                },
                unhighlight: function (element, errorClass, validClass) {
                    $( element ).closest('div' ).addClass( "has-success" ).removeClass( "has-error" );
                },
                 submitHandler: function(form) {
                     var data = new FormData(form),
                    url = $(form).attr('action'),
                    note = $(form).find('div.note');
                         
                        self.el.addClass('loading');
                        note.removeClass('alert alert-warning alert-success alert-danger');
                        
                        var respond = grecaptcha.getResponse(widgetId1),
                        allselect = $('select[name="brand_condition[]"]'),
                        length = allselect.length,
                        count = 0;
                        allselect.each(function(){
                            if($(this).val() == 'none'){
                            count++;
                            }
                        });
                        if(count == length){
                            note.removeClass('alert alert-warning alert-success alert-danger');
                            note.addClass('alert alert-warning').html('<strong>You must select at least one Condition!</strong>');
                            return false;
                        }
                        //open popup before submit function
                        var agree = $('input[name="tolerance"]:checked').val();
                        
                        if(agree != 'agree'){
                            //open popup before continues
                            $.magnificPopup.open({
                            items: {
                                src: '#agree-checking'
                              },
                              type: 'inline'
                            })
                            return false;
                        }
                        //console.log($('select[name="brand_condition[]"]').val());
                        if(respond){
                            note.addClass('alert alert-warning').html('<strong>Sending Quote....</strong>');
                            var progressBar = document.getElementById("p");
                            var request = new XMLHttpRequest();  
                            var percent = 0;
                            var interval_obj = setInterval(function(){
                                if(percent<90){
                                    percent = percent+10;
                                    $('.progress-bar').width(percent+'%').html(percent+'%');
                                }
                            }, 100);
                                request.addEventListener('progress',function(e){
                                        
                                                                  
                                
                            });
                                
                                request.addEventListener('load',function(e){                                    
                                    var respond = JSON.parse(request.responseText);
                                        if(respond.sent){
                                    note.removeClass('alert-warning');
                                    percent =100;
                                    note.addClass('alert-success').html('<strong>Message was sent!</strong> Redirecting...');
                                    $('.progress-bar').width(percent+'%').html(percent+'%');
                                    // redirect to href
                                    document.location.href = respond.redirect;                                    
                                }
                                        clearTimeout(interval_obj);
                                });
                                request.open('post', url);
                                request.send(data);
                                  /*
                                 $.ajax({
                                     url: url,
                                     type: "POST",
                                     data: data,
                                     contentType: false,       // The content type used when sending data to the server.
                                     cache: false,             // To unable request pages to be cached
                                     processData:false,        // To send DOMDocument or non processed data file it is set to false
                                     dataType: 'json',
                                     success: function(data){
                                         self.el.removeClass('loading');
                                         if(data.sent){
                                             note.removeClass('alert-warning');
                                             note.addClass('alert-success').html('<strong>Message was sent!</strong> Redirecting...');
                                             // redirect to href
                                             document.location.href = data.redirect;
                                             
                                         }
                                         
                                     }
                                 });
                                 */
                        
                        }else{
                            note.removeClass('alert alert-warning alert-success alert-danger');
                            note.addClass('alert alert-warning').html('<strong>Wrong captcha</strong>');                            
                        }
                        return false;
                    }
            });            
            self.uploadbutton.change(function(){
                var files = this.files,
                    number = files.length,
                    clone=[],
                    count=0;
                var match= ["image/jpeg","image/png","image/jpg"];
                self.uploadarea.html('');
                //console.log();
                $.each(files,function(index){
                    var file = this,
                        type = file.type;
                    
                    if(!((type==match[0]) || (type==match[1]) || (type==match[2])))
                    {
                    /* error if type != image */                        
                    }else{
                    /* this is image */
                        count++;
                        clone.push(file);
                        var render = new FileReader();
                        var src;
                        render.onload = function(e){
                            src =   e.target.result;
                            self.uploadarea.append('<div class="col-md-3"><div class="thumbnail bg-cover" style="background-image:url('+ src +')"></div></div>');
                        };
                        
                        render.readAsDataURL(file);
                        if(count==self.max) return false;
                    }
                });
                
            });
            
        },
        _starrange: function(el){
            var stars = el.find('a');
            var length = stars.length;
            stars.each(function(index){
                $(this).click(function(){
                    var select = $(this).closest('.range-area').find('select'),
                        options = select.find('option'),
                        loop=0;
                    select.val($(options[index+1]).val());
                    stars.removeClass('active');                    
                    while (loop < (index+1)) {
                        $(stars[loop]).addClass('active');
                        loop++;
                    }                    
                    return false;
                });
                
            });
            
        },
        _getclone: function(){
            var self = this,
            clone = self.listrow.find('.boxInner:last-child').clone();
            clone.find('.slider-range a').removeClass('active');
            clone.append('<span class="remove"><i class="fa fa-remove"></i><span>');
            self._removeclone(clone.find('.remove'));
            return clone;
        },
        _removeclone: function(el){
            el.click(function(){
                var clone = $(this).closest('.boxInner');
                clone.remove();
                return false;
            });
        },
        _sliderrange :function(el){            
            el.slider({
                  range: "max",
                  min: 1,
                  max: 5,
                  value: 1,
                  slide: function( event, ui ) {
                     var select = $(this).closest('.range-area').find('select'),
                         index = ui.value,
                         options = select.find('option'),
                         img = $(options[index-1]).data('src');                     
                     select.val($(options[index-1]).val());
                     $(this).find('span.ui-slider-handle').html('').append('<span><span class="tool"><img src='+img+'>'+$(options[index-1]).val()+'</span></span>');
                    
                  },
                  create: function( event, ui ) {
                      var select = $(this).closest('.range-area').find('select'),
                         index = 1,
                         options = select.find('option'),
                         img = $(options[index-1]).data('src');                     
                     select.val($(options[index-1]).val());
                     $(this).find('span.ui-slider-handle').html('').append('<span><span class="tool"><img src='+img+'>'+$(options[index-1]).val()+'</span></span>');
                      
                  }
                });    
        },
        
            
            
    }
})( window );        